module.exports = __webpack_public_path__ + "icon-apple@2x.png?a849893cf180568205f77988afc365e5";